import { NativeSelect, NativeSelectProps, NumberInput } from '@mantine/core'
import { UseFormReturnType } from '@mantine/form'
import { Category, Unit } from 'types/products'

type StockValues = {
  stock: number
  unit: Unit
}

interface Props<Values extends StockValues> {
  category: Category
  form: UseFormReturnType<Values>
  disabled?: boolean
  description?: string
  unitProps?: NativeSelectProps
  autoFocus?: boolean
}

export default function StockInput<Values extends StockValues>({
  form,
  category,
  disabled,
  description,
  autoFocus,
}: Props<Values>) {
  const isError = !!form.errors['stock']

  const withUnitSelect = false // category === Category.FABRIC
  const defaultUnit = category === Category.FABRIC ? form.values.unit || Unit.METER : Unit.PIECE

  return (
    <NumberInput
      label="Ilość"
      description={
        description ?? `Ilość produktu na stanie ${defaultUnit === Unit.PIECE ? 'w sztukach.' : 'w jednym kawałku.'}`
      }
      placeholder={defaultUnit === Unit.PIECE ? '10 szt.' : defaultUnit === Unit.METER ? '10.65 m' : '40 cm'}
      allowNegative={false}
      allowDecimal={defaultUnit !== Unit.PIECE}
      decimalScale={2}
      fixedDecimalScale
      hideControls
      suffix={defaultUnit === Unit.PIECE ? ' szt.' : defaultUnit === Unit.METER ? ' m' : ' cm'}
      decimalSeparator=","
      withAsterisk
      rightSection={
        withUnitSelect ? (
          <UnitSelect disabled={disabled} isError={isError} {...form.getInputProps('unit')} />
        ) : undefined
      }
      rightSectionWidth={withUnitSelect ? 120 : undefined}
      disabled={disabled}
      autoFocus={autoFocus}
      data-autofocus={autoFocus}
      {...form.getInputProps('stock')}
    />
  )
}

interface UnitSelectProps extends NativeSelectProps {
  isError: boolean
}

function UnitSelect({ isError, ...props }: UnitSelectProps) {
  const data: Array<{ value: Unit; label: string }> = [
    { value: Unit.METER, label: 'Metr' },
    { value: Unit.CENTIMETER, label: 'Centrymetr' },
    // { value: Unit.PIECE, label: 'Sztuka' },
  ]

  return (
    <NativeSelect
      data={data}
      rightSectionWidth={28}
      tabIndex={-1}
      styles={{
        input: {
          fontWeight: 500,
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
          width: 120,
          marginRight: -2,
          marginTop: isError ? 0 : -5,
        },
      }}
      {...props}
    />
  )
}
